<template>
	<div>
		<PageHeaderLayout :isBack="true">
			<div class="main-page-content">
				<el-row>
					<div class="flex-bw">
						<el-form :inline="true" :model="searchCondition">
							<el-form-item label="姓名">
								<el-input v-model="searchCondition.bank_account_name"></el-input>
							</el-form-item>
							<el-form-item label="缴纳状态">
								<el-select clearable v-model="searchCondition.pay_status">
									<el-option v-for="item in payStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="申报状态">
								<el-select clearable v-model="searchCondition.declare_status">
									<el-option v-for="item in declareStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="时间">
								<el-date-picker
									:picker-options="{
										disabledDate
									}"
									
									format="yyyy 年 MM 月"
									value-format="yyyyMM"
									v-model="searchCondition.month"
									type="month"
									placeholder="选择月"
								></el-date-picker>
							</el-form-item>
							<el-form-item label="服务类型">
								<el-select clearable v-model="searchCondition.category_id">
									<el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button @click="searchButton" style="color: #1890ff">查询</el-button>
							</el-form-item>
						</el-form>
					</div>
				</el-row>
				<el-row class="export-box">
					<div class="flex-bw">
						<div class="btn-box">
							<!-- <el-button @click="searchButton" type="primary">一键申报</el-button>
							<el-button @click="searchButton" type="warning">修改</el-button>
							<el-button @click="searchButton" type="danger">作废</el-button>
							<el-button @click="searchButton" type="success">缴纳</el-button>
							<el-button @click="openAccount" type="primary">配置</el-button> -->
						</div>
						<!-- <ScreeCompany :allowField="allowField" @ScreeCompany="ScreeCompany" /> -->
						<div>
							<el-select v-model="value" placeholder="请选择导出类型" @change="selectData" class="select-box" size="medium">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-button :loading="downloadLoading" style="margin: 0 0 20px 20px" type="primary" size="medium" icon="el-icon-document" @click="handleDownload">
								导出
							</el-button>
						</div>
					</div>
				</el-row>

				<ApeTable ref="apeTable" :data="companyList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
					<el-table-column width="120" header_align="center" align="center" label="申报状态">
						<template slot-scope="scope">
							<span>
								{{ declareStatusTypeList[scope.row.declare_status] }}
							</span>
						</template>
					</el-table-column>
					<el-table-column width="120" header_align="center" align="center" label="缴纳状态">
						<template slot-scope="scope">
							<span>
								{{ payStatusTypeList[scope.row.pay_status] }}
							</span>
						</template>
					</el-table-column>
					<el-table-column width="120" header_align="center" align="center" label="申报时间">
						<template slot-scope="scope">
							<span>
								{{ scope.row.declare_time }}
							</span>
						</template>
					</el-table-column>
					<el-table-column width="80" header_align="center" align="center" label="操作">
						<template slot-scope="scope">
							<span>
								<el-button size="mini" type="primary" @click="go_detail(scope.row)">查看</el-button>
							</span>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
import ApeTable from '@/components/ApeTable';
import DatePicker from '@/components/DatePicker.vue';
import { mapGetters, mapState } from 'vuex';
import ScreeCompany from '@/components/ScreeCompany.vue';
import MonthPicker from '@/components/MonthPicker.vue';
import moment from 'moment';
const declareStatusTypeList = ['待申报', '申报中', '申报成功', '申报失败'];
const payStatusTypeList = ['待缴纳', '已缴纳'];
export default {
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker,
		ScreeCompany,
		MonthPicker
	},
	data() {
		return {
			query: {},
			dialogPdfArr: [],
			dialogMultPdf: false,
			checkList: ['选中且禁用', '复选框 A'],
			companyFormData: {
				category_id: [],
				name: []
			},
			categoryList: [],

			// element的cascader的props值
			cascaderProps: {
				label: 'display_name',
				value: 'id'
			},
			searchCategory: [],
			// 搜索条件
			searchCondition: {
				month:'',
			},
			loadingStaus: true,
			payStatusTypeList,
			declareStatusTypeList,
			payStatusList: [
				{
					value: '0',
					label: '待缴纳'
				},
				{
					value: '1',
					label: '已缴纳'
				}
			],declareStatusList: [
				{
					value: '0',
					label: '待申报'
				},
				{
					value: '1',
					label: '申报中'
				},
				{
					value: '2',
					label: '申报成功'
				},
				{
					value: '3',
					label: '申报失败'
				}
			],
			// 允许显示的字段
			allowField: ['settlementId'],
			columns: [
				{
					title: '姓名',
					value: 'bank_account_name',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '收款账号',
					value: 'bank_account_no',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '下发通道',
					value: 'yl_bank_name',
					header_align: 'center',
					align: 'center'
				},
				{
					title: '附属信息',
					width: 300,
					value: [
						{ label: '证件类型：', value: 'alias_id_type' },
						{ label: '证件号码：', value: 'id_number' },
						{ label: '手机号码：', value: 'mobile' },
						{ label: '地址：', value: 'id_address' }
					],
					header_align: 'center'
					/*   align: 'center', */
				},
				{
					title: '服务类型',
					value: 'category_name',
					header_align: 'center',
					align: 'center'
				},

				{
					title: '结算金额',
					value: 'money',
					header_align: 'center',
					align: 'center'
					/*  width: 180 */
				},
				{
					title: '个税',
					value: 'accumulate_tax_money',
					header_align: 'center',
					align: 'center'
					/*  width: 180 */
				},
				{
					title: '增值税',
					value: 'added_tax_money',
					header_align: 'center',
					align: 'center'
					/*  width: 180 */
				}
			],
			// 表格列表数据
			companyList: [],
			// 分页信息
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			// 分页的offset,序号列使用
			offset: 0,

			is_import: '',
			options: [
				{
					value: 'xlsx',
					label: 'xlsx'
				},
				{
					value: 'csv',
					label: 'csv'
				},
				{
					value: 'txt',
					label: 'txt'
				}
			],
			value: 'xlsx',
			bookType: 'xlsx', //导出表格类型
			downloadLoading: false
		};
	},

	computed: {
		...mapGetters(['userPermissions', 'buttonType']),
		...mapState({
			userInfo: (state) => state.userInfo
		})
	},
	watch: {
		'$route.matched': function (n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		}
	},
	methods: {
		go_detail(row) {
			this.$router.push({ path: '/companyDetail',query:{
				id:row.id
			} });
		},

		//导出
		async handleDownload() {
			this.isExport = true;
			this.downloadLoading = true;
			let list = await this.init('export');
			import('@/excel/Export2Excel').then((excel) => {
				const tHeader = ['姓名', '收款账号', '下发通道', '证件号码', '手机号码', '地址', '服务类型', '结算金额', '个税','增值税', '申报状态', '缴纳状态', '申报时间'];
				const data = this.formatJson(list);
				const time = new Date().getTime() + Math.random() * 1000;
				let filename = `${time}`;
				excel.export_json_to_excel({
					header: tHeader, //Header Required
					data, //Specific data Required
					filename: filename, //Optional
					autoWidth: true, //Optional
					bookType: this.bookType //Optional
				});
				this.downloadLoading = false;
			});
		},
		//转换导出数据
		formatJson(jsonData) {
			return jsonData.map((v) => {
				let {
					bank_account_name,
					bank_account_no,
					yl_bank_name,
					
					id_number,
					mobile,
					id_address,
					category_name,
					money,
					accumulate_tax_money,
					added_tax_money,
					declare_status,
					pay_status,
					declare_time
				} = v;
				return [
					bank_account_name,
					bank_account_no,
					yl_bank_name,
					id_number,
					mobile,
					id_address,
					category_name,
					money,
					accumulate_tax_money,
					added_tax_money,
					this.declareStatusTypeList[declare_status],
					this.payStatusTypeList[pay_status],
					declare_time
				];
			});
		},
		//选择导出类型
		selectData(e) {
			this.bookType = e;
		},

		// 搜索
		searchButton() {
			this.init('search');
		},

		// 切换页码操作
		async switchPaging() {
			this.init();
		},

		// 初始化列表
		async init(type) {
			let pagingInfo = this.$refs['apeTable']?.getPagingInfo(type) || { current_page: 1, page_size: 10 };
			if (type == 'export') {
				pagingInfo.page_size = 50000;
				console.log(pagingInfo, '页面对象');
			} else {
				this.loadingStaus = true;
			}
			if (type == 'search') {
				pagingInfo.current_page = 1;
			}
			let searchCondition = this.handleSearchCondition();
			Object.assign(searchCondition, pagingInfo);
			let { data, pages } = await this.$api.get_qxy_declare_channel_company_list({
				...searchCondition,
				channel_name: this.query.channel_name,
				company_name: this.query.company_name
			});

			if (type == 'export') {
				return data;
			} else {
				this.companyList = [];
				this.$nextTick(() => {
					this.companyList = data;
				});
				this.pagingData.total = pages.total;
				console.log(this.pagingData.total, '总数');
				this.offset = pages.offset;
				this.loadingStaus = false;
			}
		},
		// 处理搜索条件
		handleSearchCondition() {
			return this.searchCondition;
		},

		keyupSubmit() {
			document.onkeydown = (e) => {
				console.log(e);
				let _key = window.event.keyCode;
				if (_key === 13) {
					this.searchButton();
				}
			};
		},
		disabledDate(time) {
			return time.getTime() > Date.now();
		},
		async getCategoryList() {
			let data = await this.$api.get_category_list({
				type: 'task'
			});
			this.categoryList=data.map(item=>{
				return {
					label:item.name,
					value:item.id,
				}
			})
		}
	},
	created() {
		this.keyupSubmit();
	},
	mounted() {
		this.query = this.$route.query;
		console.log(this.query);
		this.getCategoryList();
		this.searchCondition.month = moment().subtract(1, 'M').format('yyyyMM');
		this.init();
	}
};
</script>

<style lang="scss" scoped>
::v-deep .el-row {
	margin-bottom: 0;
}
.name {
	cursor: pointer;
	color: #409eff;
}
.flex-bw {
	display: flex;
	justify-content: space-between;
}
.btn-box {
	width: 360px;
	flex: none;
}
.table-right {
	float: right;
}
</style>
